import { Component, OnInit, Inject, OnDestroy ,Injectable} from '@angular/core';
import {MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { Logger, CryptoUtils } from 'msal';
import {AccountInfo,AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ConfigLoaderService } from './Config/config-loader.service';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isIframe = false;
  loggedIn = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) { }

  initializeAuth() {
    this.isIframe = window !== window.parent && !window.opener;

    this.setLoginDisplay();
   

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
       
         this.setLoginDisplay();
         this.checkAndSetActiveAccount();
        
         if(!this.loginDisplay){
        this.login();
         }
         else{
          this.getAccount();
         }
        // this.getAccount();
      })

    
  }

  // updateLoggedInStatus() {
  //   this.msalBroadcastService.inProgress$
  //     .pipe(
  //       filter((status: InteractionStatus) => status === InteractionStatus.None),
  //       takeUntil(this._destroying$)
  //     )
  //     .subscribe(() => {
  //       this.setLoggedIn();
  //       this.checkAndSetActiveAccount();
  //     });
  // }

  login() {
    // if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
    //   //this.loginWithPopup();
    // } else {
    //   this.loginWithRedirect();
    // }
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest){
        this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
        } else {
          this.authService.loginPopup()
            .subscribe((response: AuthenticationResult) => {
              this.authService.instance.setActiveAccount(response.account);
            });
      }
    } else {
     
      if (this.msalGuardConfig.authRequest){
        this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  // getActiveAccount(): AccountInfo | null {
  //   return this.authService.instance.getActiveAccount();
  // }

  checkAndSetActiveAccount() {
    /**
    * If no active account set but there are accounts signed in, sets first account to active account
    * To use active account set here, subscribe to inProgress$ first in your component
    * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
    */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  // private setLoggedIn() {
  //   this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
  // }

  // private loginWithRedirect() {
  //   if (this.msalGuardConfig.authRequest) {
  //     this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
  //   } else {
  //     this.authService.loginRedirect();
  //   }
  // }

  logout() {
    this.authService.logoutRedirect();
  }

  setLoginDisplay() {
   
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;  
   
    if(!this.loginDisplay){
      this.checkAndSetActiveAccount();
      this.login();
      
     
    }   
    else{
     // this.checkAndSetActiveAccount();
      this.getAccount();
     
    }
   
  }

  getAccount(){
    
    const currentAccounts=this.authService.instance.getAllAccounts();
   
   
    if (currentAccounts === null) {
      return;
    } else if (currentAccounts.length > 1) {
      // Add choose account code here
      console.warn("Multiple accounts detected.");
  } else if (currentAccounts.length === 1) {
      ConfigLoaderService.settings.AppSettings.userId = currentAccounts[0].username.split('@')[0];
      
  }
  }


  // checkoutAccount() {   
  //   this.loggedIn = !!this.msalService.getAccount();
  // }

  // login() {
  //   console.log(this.msalGuardConfig.interactionType )
  //   if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
  //     if (this.msalGuardConfig.authRequest) {
  //       this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
  //         .subscribe((response: AuthenticationResult) => {
  //           this.authService.instance.setActiveAccount(response.account);
  //         });
  //     } else {
  //       this.authService.loginPopup()
  //         .subscribe((response: AuthenticationResult) => {
  //           this.authService.instance.setActiveAccount(response.account);
  //         });
  //     }
  //   } else {
  //     if (this.msalGuardConfig.authRequest) {
  //       this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
  //     } else {
  //       this.authService.loginRedirect();
  //     }
  //   }
  // }

  // logout() {
  //   this.authService.logout();
  // }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
